import { createFileRoute } from '@tanstack/react-router'

import SubmissionPage from '@/components/pages/backoffice/_klb-petani/_gapoktan/submission/containers/SubmissionPage'

export const Route = createFileRoute('/_backoffice/klb-petani/gapoktan/submission/')({
  component: SubmissionPage
})
